<template>
  <ComplianceDataFieldRow :label="data.label" :value="data.value ?? null" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import ComplianceDataFieldRow from './ComplianceDataFieldRow.vue'
import { FragmentType, graphql, useFragment } from '@/gql'

const ComplianceDataFieldFragment = graphql(`
  fragment ComplianceDataField on ComplianceDataField {
    label
    value
  }
`)

const props = defineProps<{ entry: FragmentType<typeof ComplianceDataFieldFragment> }>()
const data = computed(() => useFragment(ComplianceDataFieldFragment, props.entry))
</script>
